/* nt-aied-s2.js — v3 Edit-with-AI popup on the single-upload legacy engine
 * (pdp_transferBySize.js pages: stickers, magnets, graphics, window clings,
 * puff). Owen 2026-08-31 "push the interactive ai edit popup to all pdps".
 *
 * Same shape as nt-aied-s1.js: the v4 dialog chunk (assets/bysize-v4-edit.js)
 * is reused VERBATIM behind a window.__bsv4Bridge adapter; the existing
 * .edit-with-ai buttons are re-targeted in capture phase so the legacy modal
 * (.customTabelPopup__overlay-ai) never shows.
 *
 * APPLY strategy differs from s1 ON PURPOSE: this engine's AI state lives in
 * top-level `let` globals (isAIEdit / aiOriginalUrl, pdp_transferBySize.js:36)
 * that page-external code CANNOT set — and later property re-stamps read
 * them. So the writeback feeds the finished image back through the page's OWN
 * #use_ai_image handler (seed #ai_image_preview with our hosted result, click
 * the button): every legacy side effect — S3 re-host, hero swap,
 * executeNextStep, hidden props, enableBgRemoveAfterAI — runs exactly as it
 * does today, with the script-scoped globals set from inside. Costs one
 * duplicate S3 object per apply; buys zero behavioral drift.
 */
(function () {
  'use strict';
  if (window.__ntAiedS2) return;
  window.__ntAiedS2 = true;

  var host = document.querySelector('[data-nt-aied-host]');
  if (!host) return;
  var PROXY_URL = 'https://ruhg140mmf.execute-api.us-east-1.amazonaws.com/';
  var FILE_ID = 's2-1'; // single-upload engine: exactly one artwork slot

  var cache = {};
  function heroSrc() {
    var img = document.getElementById('fileupload_hero');
    return (img && img.getAttribute('src')) || '';
  }
  function fileFor() {
    var src = heroSrc();
    var s3 = window.originalUploadedFileURL || '';
    if (!src && !s3) return null;
    var f = cache[FILE_ID] || (cache[FILE_ID] = { id: FILE_ID });
    // Source signature guard: applyResult MUTATES this object (new s3/imgix
    // urls) and then calls getState() BEFORE the file-edited announce — a
    // blind refresh here clobbered the fresh edit back to the original
    // (2026-08-31 sandbox repro: red-sky result, blue-sky hero). Only rebuild
    // from the engine when the ENGINE's own source actually changed.
    var sig = src + '|' + s3;
    if (f.__sig === sig) return f;
    f.__sig = sig;
    var base = String(s3 || src).split('/').pop().split('?')[0] || 'design.png';
    f.name = base;
    f.uploadName = base;
    f.s3Url = s3 || src;
    f.imgixUrl = src.indexOf('imgix') >= 0 ? src.split('?')[0] : src;
    f.crc = null;
    f.ext = (base.split('.').pop() || 'png').toLowerCase();
    f.isAIEdit = !!window.__aiEditOriginalUrl;
    f.originalUploadReference = f.originalUploadReference || s3 || '';
    f.aiEditCount = f.aiEditCount || 0;
    f.params = f.params || { preview: '?auto=format,compress' };
    return f;
  }

  function imgixHostFromPage() {
    var cands = [
      window.ninjaImgixHost || '',
      (document.getElementById('fileupload_hero') || {}).src || '',
    ];
    var imgs = document.querySelectorAll('img[src*="imgix.net"]');
    for (var i = 0; i < imgs.length && i < 5; i++) cands.push(imgs[i].src);
    for (var j = 0; j < cands.length; j++) {
      var m = String(cands[j]).match(/([a-z0-9.-]+\.imgix\.net)/i);
      if (m) return m[1];
    }
    return 'ninjauploads-production.imgix.net'; // prod default (hero-verified 2026-08-31)
  }
  function buildUploadName(fileName) {
    var nameOnly = String(fileName).split('.')[0].toLowerCase().replace(/[^a-z0-9]/gi, '-').replace(/-+/g, '-').replace(/^-|-$/g, '');
    var ext = /\.[a-z0-9]{1,5}$/i.test(fileName) ? fileName.split('.').pop() : 'png';
    return nameOnly + '____image_' + Date.now() + '_' + Math.floor(Math.random() * 1000) + '.' + ext;
  }
  async function uploadBlob(file) {
    var uploadName = buildUploadName(file.name);
    var presign = await window.getPresignedUploadUrl(uploadName, file.type);
    if (!presign || !presign.url) throw new Error('presign unavailable');
    var put = await fetch(presign.url, { method: 'PUT', headers: { 'Content-Type': file.type }, body: file });
    if (!put.ok) throw new Error('S3 PUT failed (' + put.status + ')');
    // The engines' ninjaImgixHost is a script-scoped let (not on window), so
    // derive the real imgix host from an URL the page itself is serving.
    var imgixHost = imgixHostFromPage();
    return { uploadName: uploadName, crc: null, s3Url: presign.sourceUrl, imgixUrl: 'https://' + imgixHost + '/' + uploadName };
  }

  async function nbEdit(imageUrl, promptText) {
    var resp = await fetch(PROXY_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ model: 'gram-edit-45g', imageUrl: imageUrl, prompt: promptText, transparency: 'AUTO' }),
    });
    if (!resp.ok) {
      var txt = await resp.text().catch(function () { return ''; });
      throw new Error('AI edit request failed (' + resp.status + '): ' + txt.slice(0, 200));
    }
    var data = await resp.json();
    if (!data || !data.url) throw new Error('AI edit response missing url');
    return data.url + (data.url.indexOf('?') >= 0 ? '&' : '?') + 'cs=strip';
  }

  function writeback(id) {
    var f = cache[id];
    if (!f || !f.imgixUrl || !window.jQuery) return;
    var $ = window.jQuery;
    var img = $('#ai_image_preview');
    if (!img.length || !$('#use_ai_image').length) return;
    img.attr('src', f.imgixUrl);
    // The legacy modal stays hidden; its apply handler neither needs nor
    // shows it. It ends by re-hiding the overlay, which is a no-op here.
    $('#use_ai_image').trigger('click');
  }

  function assembleBridge() {
    window.__bsv4Bridge = {
      getState: function () { var f = fileFor(); return { files: f ? [f] : [], activeFileId: FILE_ID }; },
      update: function () {},
      announce: function (evt, detail) {
        if (evt === 'file-edited' && detail && detail.id) {
          try { writeback(detail.id); } catch (e) { console.error('nt-aied-s2 writeback', e); }
        }
      },
      subscribe: function () { return function () {}; },
      uploadBlob: uploadBlob,
      intakeFromUrls: function () {},
      previewUrl: function (f) { return heroSrc() || f.imgixUrl || f.s3Url || ''; },
      resolveDimensions: function () { return Promise.resolve({}); },
      nbEdit: nbEdit,
      refitRowsToAspect: function () {},
      IMGIX_HOST: (window.ninjaImgixHost || '').replace(/^https?:\/\//, ''),
      S3_HOST: (window.ninjaS3Host2 || '').replace(/^https?:\/\//, ''),
      gaApi: { fire: function () {}, uploadIndex: function () { return 0; }, inModal: function () { return false; } },
      cfg: {
        falKey: host.getAttribute('data-nt-aied-on') || '',
        preview: { aiEdit: true },
        imgixParams: { png: '?auto=format,compress' },
      },
    };
    if (!window.__bsv4) window.__bsv4 = { update: function () {} };
  }

  var chunkLoading = false;
  function openV3() {
    var go = function () { window.__bsv4AiedOpenFor(FILE_ID); };
    if (window.__bsv4AiedOpenFor) return go();
    if (chunkLoading) return;
    chunkLoading = true;
    assembleBridge();
    var s = document.createElement('script');
    s.src = host.getAttribute('data-nt-aied-editjs');
    s.onload = go;
    s.onerror = function () {
      chunkLoading = false;
      s.remove();
      var legacy = document.querySelector('.customTabelPopup__overlay-ai');
      if (legacy) legacy.style.display = 'grid'; // never a dead button
    };
    document.body.appendChild(s);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.edit-with-ai');
    if (!btn) return;
    if (window.canUseAiRequest && !window.canUseAiRequest()) {
      if (window.showRedToast) window.showRedToast('Daily AI limit reached — try again tomorrow.');
      e.preventDefault(); e.stopPropagation();
      return;
    }
    if (!fileFor()) return; // nothing uploaded — let the old path decide
    e.preventDefault();
    e.stopPropagation();
    openV3();
  }, true);
})();
